import SuspenseLoader from 'components/SuspenseLoader';
import { ComponentType, lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';

const Loader = (Component: ComponentType) => {
  const WithSuspense = (props: object) => (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );
  WithSuspense.displayName = 'WithSuspense';
  return WithSuspense;
};

// Pages



// Status

const Status404 = Loader(lazy(() => import('content/pages/Status/Status404')));
const Status500 = Loader(lazy(() => import('content/pages/Status/Status500')));
const StatusComingSoon = Loader(
  lazy(() => import('content/pages/Status/ComingSoon'))
);
const StatusMaintenance = Loader(
  lazy(() => import('content/pages/Status/Maintenance'))
);

const baseRoutes = [
  // {
  //   path: '/',
  //   element: <Overview />
  // },
  // {
  //   path: 'overview',
  //   element: <Navigate to="/" replace />
  // },
  {
    path: '/',
    element: <Navigate to="/accent-sidebar/services" replace />,
  },
  {
    path: '*',
    element: <Status404 />,
  },
  {
    path: 'status',
    children: [
      {
        path: '500',
        element: <Status500 />,
      },
      {
        path: 'maintenance',
        element: <StatusMaintenance />,
      },
      {
        path: 'coming-soon',
        element: <StatusComingSoon />,
      },
    ],
  },
  {
    path: '*',
    element: <Status404 />,
  },
];

export default baseRoutes;
